
export default class CurrencyHelper {

    static convertCentimesToEuros(amount: number): number {
        return (amount / 100)
    }

}